/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Signing_In_Button_2Inputs */

const en_login_signing_in_button_2 = /** @type {(inputs: Login_Signing_In_Button_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signing In...`)
};

const fr_login_signing_in_button_2 = /** @type {(inputs: Login_Signing_In_Button_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connexion en cours...`)
};

const de_login_signing_in_button_2 = /** @type {(inputs: Login_Signing_In_Button_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmelden...`)
};

const it_login_signing_in_button_2 = /** @type {(inputs: Login_Signing_In_Button_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accesso in corso...`)
};

const ru_login_signing_in_button_2 = /** @type {(inputs: Login_Signing_In_Button_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вход в систему...`)
};

const es_login_signing_in_button_2 = /** @type {(inputs: Login_Signing_In_Button_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciando sesión...`)
};

const zh_cn2_login_signing_in_button_2 = /** @type {(inputs: Login_Signing_In_Button_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在登录……`)
};

const ja_login_signing_in_button_2 = /** @type {(inputs: Login_Signing_In_Button_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サインイン中...`)
};

const hi_login_signing_in_button_2 = /** @type {(inputs: Login_Signing_In_Button_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इन कर रहे हैं...`)
};

const pt_pt2_login_signing_in_button_2 = /** @type {(inputs: Login_Signing_In_Button_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrando...`)
};

/**
* | output |
* | --- |
* | "Signing In..." |
*
* @param {Login_Signing_In_Button_2Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_signing_in_button_2 = /** @type {((inputs?: Login_Signing_In_Button_2Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Signing_In_Button_2Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_login_signing_in_button_2(inputs)
	if (locale === "de") return de_login_signing_in_button_2(inputs)
	if (locale === "it") return it_login_signing_in_button_2(inputs)
	if (locale === "ru") return ru_login_signing_in_button_2(inputs)
	if (locale === "es") return es_login_signing_in_button_2(inputs)
	if (locale === "zh-CN") return zh_cn2_login_signing_in_button_2(inputs)
	if (locale === "ja") return ja_login_signing_in_button_2(inputs)
	if (locale === "hi") return hi_login_signing_in_button_2(inputs)
	if (locale === "pt-PT") return pt_pt2_login_signing_in_button_2(inputs)
	return en_login_signing_in_button_2(inputs)
});